require('jquery-migrate');
Promise.polyfill();
$.browser = { msie: true };
jQuery.migrateMute = true;
// require('../vendor/strangeanimals/requirements-ss4/thirdparty/tinymce/tinymce.min.js');
// require('../vendor/strangeanimals/requirements-ss4/thirdparty/tinymce/jquery.tinymce.min.js');
require('lazyload');
require(['lightbox2'], function(lightbox) {
    lightbox.option({
        resizeDuration: 200,
        wrapAround: true,
        showImageNumberLabel: false
    });
});
require('slick-carousel');
require('sumoselect');
require('bootstrap');
require('imagesloaded');
require('jquery-nstslider/src/jquery.nstSlider');
require('./js/homegroup/table');
require('./js/landfinder/table');

import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import * as Sentry from '@sentry/browser';

window.Sentry = Sentry;

UIkit.use(Icons);
window.UIkit = UIkit;
